import { createAction, props } from '@ngrx/store';
import { Opinion } from '../../../shared/interfaces/opinion';
import { FAQ } from '../../../shared/interfaces/faq';
import { IProduct } from '../../../shared/interfaces/IProduct';

export const getOpinions = createAction('[Opinions] Get');
export const getOpinionsSuccess = createAction(
  '[Opinions] Get Success',
  props<{ opinions: Opinion[] }>()
);
export const getOpinionsError = createAction(
  '[Opinions] Get Error',
  props<{ error: any }>()
);

export const getFAQS = createAction('[FAQS] Get');
export const getFAQSSuccess = createAction(
  '[FAQS] Get Success',
  props<{ FAQS: FAQ[] }>()
);
export const getFAQSError = createAction(
  '[FAQS] Get Error',
  props<{ error: any }>()
);

export const getProduct = createAction(
  '[Product Detail] Get Product',
  props<{ id: number; zipCode?: number; periodicity?: number }>()
);
export const getProductError = createAction(
  '[Product Detail] Get Product Error',
  props<{ error: any }>()
);
export const getProductSuccess = createAction(
  '[Product Detail] Get Product Success',
  props<{ product: IProduct }>()
);

// Acciones para cupones de descuento
export const validateCoupon = createAction(
  '[Coupon] Validate Coupon',
  props<{ code: string }>()
);
export const validateCouponSuccess = createAction(
  '[Coupon] Validate Coupon Success',
  props<{ discount: any; products: IProduct[] }>()
);
export const validateCouponError = createAction(
  '[Coupon] Validate Coupon Error',
  props<{ error: any }>()
);
export const clearCoupon = createAction('[Coupon] Clear Coupon');
